<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-documents">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <div class="d-flex justify-content-between align-items-center">
                                <mat-card-title>
                                    <i class="fa-solid fa-file"></i>
                                    <span>Documente atașate</span>
                                </mat-card-title>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="p-2 d-flex justify-content-end">
                        <button class="btn btn-sm" [ngClass]="showUploadPanel ? 'btn-warning' : 'btn-primary'"
                            (click)="toggleUploadPanel()">
                            <i class="fa-solid" [ngClass]="showUploadPanel ? 'fa-times' : 'fa-plus'"></i>
                            {{ showUploadPanel ? 'Anulează' : 'Adaugă Document' }}
                        </button>
                    </div>

                    <mat-divider></mat-divider>

                    <ng-container *ngIf="!showUploadPanel">
                        <div class="p-2 d-flex flex-column gap-2 mb-3">
                            <!-- Category pills -->
                            <div>
                                <div class="filter-section-label">Categorii</div>
                                <div class="d-flex flex-wrap gap-2">
                                    <button class="category-pill" [class.active]="activeCategory === null"
                                        (click)="filterByCategory(null)">
                                        <i class="fa-solid fa-layer-group"></i> Toate
                                    </button>
                                    <button *ngFor="let cat of documentCategories" class="category-pill"
                                        [class.active]="activeCategory === cat.slug"
                                        (click)="filterByCategory(cat.slug)">
                                        <i [ngClass]="DosarCategoryIcons[cat.slug]"></i>
                                        {{ cat.name }}
                                    </button>
                                </div>
                            </div>

                            <!-- Filter bar -->
                            <div>
                                <div class="filter-section-label">Filtre &amp; Vizualizare</div>
                                <div class="d-flex align-items-center flex-wrap gap-2">
                                    <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                                        <mat-label>De la</mat-label>
                                        <input matInput [matDatepicker]="pickerFrom" [formControl]="dateFrom"
                                            [min]="minDate" [max]="dateTo.value ?? maxDate" placeholder="dd/mm/yyyy"
                                            readonly (focus)="pickerFrom.open()" (dateChange)="onFilterChange()">
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerFrom></mat-datepicker>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                                        <mat-label>Până la</mat-label>
                                        <input matInput [matDatepicker]="pickerTo" [formControl]="dateTo"
                                            [min]="dateFrom.value ?? minDate" [max]="maxDate" placeholder="dd/mm/yyyy"
                                            readonly (focus)="pickerTo.open()" (dateChange)="onFilterChange()">
                                        <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerTo></mat-datepicker>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                                        <mat-label>Tag</mat-label>
                                        <mat-select [formControl]="filterTags" (selectionChange)="onFilterChange()"
                                            (openedChange)="onSearchTagsClosed()">
                                            <mat-form-field class="px-2 sticky-input">
                                                <input matInput [formControl]="searchTagsControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>
                                            <mat-option *ngIf="filteredSearchTags.length === 0" disabled>
                                                <span>Nu au fost găsite rezultate</span>
                                            </mat-option>
                                            <mat-option [value]="-1">Toate</mat-option>
                                            <mat-option *ngFor="let item of filteredSearchTags" [value]="item.id">
                                                {{ item.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <div class="view-toggle">
                                        <button [class.active]="currentView === ViewMode.BY_CATEGORY"
                                            (click)="setViewMode(ViewMode.BY_CATEGORY)" matTooltip="Pe categorii">
                                            <i class="fa-solid fa-folder"></i>
                                        </button>
                                        <button [class.active]="currentView === ViewMode.BY_DATE"
                                            (click)="setViewMode(ViewMode.BY_DATE)" matTooltip="Cronologic">
                                            <i class="fa-solid fa-clock"></i>
                                        </button>
                                        <button [class.active]="currentView === ViewMode.BY_TAG"
                                            (click)="setViewMode(ViewMode.BY_TAG)" matTooltip="Tag">
                                            <i class="fa-solid fa-tags"></i>
                                        </button>
                                    </div>

                                    <div class="view-toggle">
                                        <button [class.active]="currentOrder === OrderMode.DESCENDING"
                                            (click)="setOrder(OrderMode.DESCENDING)"
                                            matTooltip="Sortare descrescătoare">
                                            <i class="fa-solid fa-arrow-down"></i>
                                        </button>
                                        <button [class.active]="currentOrder === OrderMode.ASCENDING"
                                            (click)="setOrder(OrderMode.ASCENDING)" matTooltip="Sortare crescătoare">
                                            <i class="fa-solid fa-arrow-up"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <mat-divider class="my-2"></mat-divider>

                            <!-- View docs -->
                            <div class="ms-2 text-center" *ngIf="!viewCards.length">
                                <strong><i>Lipsă înregistrări</i></strong>
                            </div>

                            <div class="ms-2" *ngFor="let card of viewCards">
                                <!-- Group header -->
                                <div class="mb-2">
                                    <span *ngIf="card.icon">
                                        <i class="fa-solid" [ngClass]="card.icon"></i> &nbsp;{{ card.label }}
                                    </span>
                                    <div *ngIf="card.color" class="px-2 py-1 rounded d-inline-block"
                                        [style.backgroundColor]="card.color">
                                        <span style="color: #ffffff; font-size: 13px;">{{ card.label }}</span>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>

                                <!-- Cards grid -->
                                <div class="doc-cards-grid py-2">
                                    <div *ngFor="let group of card.fileGroups" class="doc-card">

                                        <!-- Header row: category badge + created date -->
                                        <div class="doc-card-header">
                                            <span class="doc-cat-badge">
                                                <i [ngClass]="DosarCategoryIcons[group.category_slug]"></i>
                                                {{ group.category_name }}
                                            </span>
                                            <span class="doc-created-date">
                                                {{ group.created_at | date: "dd.MM.yyyy" : "ro" }}
                                            </span>
                                        </div>

                                        <!-- Meta grid -->
                                        <div class="doc-meta"
                                            *ngIf="group.updated_at || group.document_nr || group.document_date">
                                            <ng-container *ngIf="group.updated_at">
                                                <span class="lbl">Ultima actualizare:</span>
                                                <span class="val">{{ group.updated_at | date: "dd.MM.yyyy" : "ro"
                                                    }}</span>
                                            </ng-container>
                                            <ng-container *ngIf="group.document_nr">
                                                <span class="lbl">Nume document:</span>
                                                <span class="val">{{ group.document_nr }}</span>
                                            </ng-container>
                                            <ng-container *ngIf="group.document_date">
                                                <span class="lbl">Dată document:</span>
                                                <span class="val">{{ group.document_date | date: "dd.MM.yyyy" : "ro"
                                                    }}</span>
                                            </ng-container>
                                        </div>

                                        <!-- Tags -->
                                        <div *ngIf="group.tags.length">
                                            <div class="filter-section-label mb-1">Tag-uri</div>
                                            <div class="doc-tags-row">
                                                <span *ngFor="let tag of group.tags" class="px-2 py-1 rounded"
                                                    style="font-size: 11px; color: #fff;"
                                                    [style.backgroundColor]="tag.color">
                                                    {{ tag.name }}
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Files -->
                                        <div>
                                            <div class="filter-section-label mb-1">Documente încărcate</div>
                                            <div class="doc-files-row">
                                                <button *ngFor="let file of group.files" type="button"
                                                    class="doc-file-btn" (click)="downloadFile(file.id)">
                                                    <i class="fa-solid fa-download"></i>
                                                    {{ file.original_name }}
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Actions -->
                                        <div class="doc-card-actions">
                                            <button type="button" class="action-btn action-btn-edit"
                                                (click)="openEditPanel(group)">
                                                <i class="fa-regular fa-pen-to-square"></i>
                                                Editare
                                            </button>
                                            <button type="button" class="action-btn action-btn-delete"
                                                (click)="deleteDocument(group)">
                                                <i class="fa-regular fa-trash-can"></i>
                                                Ștergere
                                            </button>
                                            <button type="button" class="action-btn action-btn-view"
                                                (click)="viewDocument(group)">
                                                <i class="fa-regular fa-eye"></i>
                                                Vizualizare
                                            </button>
                                            <button type="button" class="action-btn action-btn-istoric"
                                                (click)="openIstoricDocument(group)">
                                                <i class="fa-solid fa-clock-rotate-left"></i>
                                                Istoric
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showUploadPanel">
                        <div class="p-2 d-flex flex-column">
                            <div class="d-flex flex-row flex-wrap justify-content-between align-items-start mb-2">
                                <h4 class="m-0">{{ editData ? 'Editare Documente' : 'Încărcare Documente' }}</h4>
                                <button class="btn btn-sm btn-success" (click)="addTagToNomenclator()">
                                    <i class="fa-solid fa-plus"></i>
                                    Adaugă Tag
                                </button>
                            </div>
                            <form [formGroup]="form">
                                <div class="row">
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Dosar (Categorie)</mat-label>
                                            <mat-select formControlName="category_id"
                                                (selectionChange)="onCategoryChange($event.value)">
                                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                <mat-option *ngFor="let cat of documentCategories" [value]="cat.id">{{
                                                    cat.name }}</mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="!form.controls['category_id'].valid && form.controls['category_id'].touched">
                                                Selectați o opțiune
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Tag Document</mat-label>
                                            <mat-select formControlName="tag_id" (selectionChange)="addTagInArray()"
                                                (openedChange)="onDocumentTagsClosed()">
                                                <mat-form-field class="px-2 sticky-input">
                                                    <input matInput [formControl]="documentTagsControl"
                                                        (keydown)="$event.stopPropagation()"
                                                        (click)="$event.stopPropagation()" />
                                                </mat-form-field>
                                                <mat-option *ngIf="filteredDocumentTags.length === 0" disabled>
                                                    <span>Nu au fost găsite rezultate</span>
                                                </mat-option>

                                                <mat-option *ngFor="let item of filteredDocumentTags" [value]="item.id">
                                                    {{ item.name }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="!form.controls['tag_id'].valid && form.controls['tag_id'].touched">
                                                Selectați o opțiune
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div *ngIf="!tagArr.length" class="mb-3">
                                    <mat-error>
                                        Adăugați minim un tag
                                    </mat-error>
                                </div>

                                <div *ngIf="tagArr.length" class="mb-3 d-flex flex-wrap gap-2">
                                    <div *ngFor=" let tag of tagArr; let i=index"
                                        class="d-flex align-items-center gap-1 px-2 py-1 rounded"
                                        [style.backgroundColor]="tag.color">
                                        <span style="color: #ffffff; font-size: 14px;">{{tag.name}}</span>
                                        <mat-icon
                                            style="font-size: 16px; width: 16px; height: 16px; color: #ffffff; cursor: pointer;"
                                            (click)="removeTagInArray(i)">cancel</mat-icon>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Număr document</mat-label>
                                            <input type="text" matInput formControlName="document_nr" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Dată document</mat-label>
                                            <input matInput [matDatepicker]="documentDatePicker"
                                                formControlName="document_date" readonly
                                                (focus)="documentDatePicker.open()" />
                                            <mat-hint>ZZ/LL/AAAA</mat-hint>
                                            <mat-datepicker-toggle matIconSuffix
                                                [for]="documentDatePicker"></mat-datepicker-toggle>
                                            <mat-datepicker #documentDatePicker></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md">
                                        <mat-form-field class="w-100" appearance="fill">
                                            <mat-label>Observații</mat-label>
                                            <textarea matInput formControlName="observations"></textarea>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <ng-container *ngIf="activeCategorySelect === 'dosar-medical'">
                                    <h4 class=""><i [ngClass]="DosarCategoryIcons['dosar-medical']"></i> Informații
                                        Medicale
                                    </h4>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Secțiune</mat-label>
                                                <mat-select formControlName="medical_section">
                                                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                                                    <mat-option *ngFor="let section of documentSections"
                                                        [value]="section.id">{{
                                                        section.name }}</mat-option>
                                                </mat-select>
                                                <mat-error
                                                    *ngIf="!form.controls['medical_section'].valid && form.controls['medical_section'].touched">
                                                    Selectați o opțiune
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Tip condiție medicală</mat-label>
                                                <mat-select formControlName="medical_condition_type"
                                                    (openedChange)="onConditieMedicalaClosed()">
                                                    <mat-form-field class="px-2 sticky-input">
                                                        <input matInput [formControl]="conditieMedicalaControl"
                                                            (keydown)="$event.stopPropagation()"
                                                            (click)="$event.stopPropagation()" />
                                                    </mat-form-field>
                                                    <mat-option *ngIf="filteredConditieMedicala.length === 0" disabled>
                                                        <span>Nu au fost găsite rezultate</span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let item of filteredConditieMedicala"
                                                        [value]="item.id">
                                                        {{ item.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Tip eveniment genealogic</mat-label>
                                                <mat-select formControlName="genealogical_event_type"
                                                    (openedChange)="onEvenimentGenealogicClosed()">
                                                    <mat-form-field class="px-2 sticky-input">
                                                        <input matInput [formControl]="evenimentGenealogicControl"
                                                            (keydown)="$event.stopPropagation()"
                                                            (click)="$event.stopPropagation()" />
                                                    </mat-form-field>
                                                    <mat-option *ngIf="filteredEvenimentGenealogic.length === 0"
                                                        disabled>
                                                        <span>Nu au fost găsite rezultate</span>
                                                    </mat-option>

                                                    <mat-option *ngFor="let item of filteredEvenimentGenealogic"
                                                        [value]="item.id">
                                                        {{ item.name }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Medic</mat-label>
                                                <input type="text" matInput formControlName="doctor_name" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Clinică</mat-label>
                                                <input type="text" matInput formControlName="clinic_name" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Diagnostic</mat-label>
                                                <input type="text" matInput formControlName="diagnosis" />
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Tratament</mat-label>
                                                <input type="text" matInput formControlName="treatment" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Data următorului control</mat-label>
                                                <input matInput [matDatepicker]="nextControlPicker"
                                                    formControlName="date_next_checkup" readonly
                                                    (focus)="nextControlPicker.open()" />
                                                <mat-hint>ZZ/LL/AAAA</mat-hint>
                                                <mat-datepicker-toggle matIconSuffix
                                                    [for]="nextControlPicker"></mat-datepicker-toggle>
                                                <mat-datepicker #nextControlPicker></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </ng-container>
                                <!-- Informații Educaționale -->
                                <ng-container *ngIf="activeCategorySelect === 'dosar_educational'">
                                    <h4 class=""><i [ngClass]="DosarCategoryIcons['dosar_educational']"></i> Informații
                                        Educaționale</h4>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Instituție</mat-label>
                                                <input type="text" matInput formControlName="institution_name" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Locație</mat-label>
                                                <input type="text" matInput formControlName="location" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Tip Studii</mat-label>
                                                <input type="text" matInput formControlName="degree_type" />
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Specializare</mat-label>
                                                <input type="text" matInput formControlName="specialization" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Status</mat-label>
                                                <mat-select formControlName="edu_status">
                                                    <mat-option *ngFor="let item of eduStatus" [value]="item.value">{{
                                                        item.name }}</mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Dată începere</mat-label>
                                                <input matInput [matDatepicker]="dateFromPicker"
                                                    formControlName="date_from" readonly
                                                    (focus)="dateFromPicker.open()" />
                                                <mat-hint>ZZ/LL/AAAA</mat-hint>
                                                <mat-datepicker-toggle matIconSuffix
                                                    [for]="dateFromPicker"></mat-datepicker-toggle>
                                                <mat-datepicker #dateFromPicker></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Dată finalizare</mat-label>
                                                <input matInput [matDatepicker]="dateToPicker" formControlName="date_to"
                                                    readonly (focus)="dateToPicker.open()" />
                                                <mat-hint>ZZ/LL/AAAA</mat-hint>
                                                <mat-datepicker-toggle matIconSuffix
                                                    [for]="dateToPicker"></mat-datepicker-toggle>
                                                <mat-datepicker #dateToPicker></mat-datepicker>
                                                <mat-error
                                                    *ngIf="form.controls['date_to'].hasError('invalidDateRange') && form.controls['date_to'].touched">
                                                    Selectați o perioadă validă
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-checkbox color="primary" formControlName="has_breaks">Are
                                                întreruperi în studii</mat-checkbox>
                                        </div>
                                    </div>
                                    <div class="row" *ngIf="form.get('has_breaks')?.value">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Detalii întreruperi</mat-label>
                                                <textarea matInput formControlName="break_details"></textarea>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- Informații Juridice -->
                                <ng-container *ngIf="activeCategorySelect === 'dosar_juridic'">
                                    <h4 class=""><i [ngClass]="DosarCategoryIcons['dosar_juridic']"></i> Informații
                                        Juridice</h4>
                                    <div class="row">
                                        <!-- <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Număr dosar</mat-label>
                                                <input type="text" matInput formControlName="case_number" />
                                            </mat-form-field>
                                        </div> -->
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Instanță</mat-label>
                                                <input type="text" matInput formControlName="court_name" />
                                            </mat-form-field>
                                        </div>
                                        <!-- <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Data înscrierii</mat-label>
                                                <input matInput [matDatepicker]="inscriptionDatePicker"
                                                    formControlName="inscription_date" readonly
                                                    (focus)="inscriptionDatePicker.open()" />
                                                <mat-hint>ZZ/LL/AAAA</mat-hint>
                                                <mat-datepicker-toggle matIconSuffix
                                                    [for]="inscriptionDatePicker"></mat-datepicker-toggle>
                                                <mat-datepicker #inscriptionDatePicker></mat-datepicker>
                                            </mat-form-field>
                                        </div> -->
                                    </div>
                                </ng-container>

                                <!-- Informații Psihologice -->
                                <ng-container *ngIf="activeCategorySelect === 'dosar_psihologic'">
                                    <h4 class=""><i [ngClass]="DosarCategoryIcons['dosar_psihologic']"></i> Informații
                                        Psihologice</h4>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Specialist</mat-label>
                                                <input type="text" matInput formControlName="specialist_name" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Tip evaluare</mat-label>
                                                <input type="text" matInput formControlName="evaluation_type" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Diagnostic</mat-label>
                                                <input type="text" matInput formControlName="diagnosis" />
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Recomandări</mat-label>
                                                <textarea matInput formControlName="recommendations"></textarea>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </ng-container>

                                <!-- Informații Familiale -->
                                <ng-container *ngIf="activeCategorySelect === 'dosar_familial'">
                                    <h4 class=""><i [ngClass]="DosarCategoryIcons['dosar_familial']"></i> Informații
                                        Familiale</h4>
                                    <div class="row">
                                        <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Subtip Document</mat-label>
                                                <input type="text" matInput formControlName="document_subtype" />
                                            </mat-form-field>
                                        </div>
                                        <!-- <div class="col-md">
                                            <mat-form-field class="w-100" appearance="fill">
                                                <mat-label>Data înscrierii</mat-label>
                                                <input matInput [matDatepicker]="inscriptionDate2Picker"
                                                    formControlName="inscription_date" readonly
                                                    (focus)="inscriptionDate2Picker.open()" />
                                                <mat-hint>ZZ/LL/AAAA</mat-hint>
                                                <mat-datepicker-toggle matIconSuffix
                                                    [for]="inscriptionDate2Picker"></mat-datepicker-toggle>
                                                <mat-datepicker #inscriptionDate2Picker></mat-datepicker>
                                            </mat-form-field>
                                        </div> -->
                                    </div>

                                    <h4>Persoane implicate</h4>

                                    <div *ngIf="involvedPersons.length > 0" class="mb-3">
                                        <div *ngFor="let person of involvedPersons; let i = index"
                                            class="border rounded p-2 mb-2 d-flex justify-content-between align-items-center">
                                            <div>
                                                <strong>{{ person.full_name }}</strong>
                                                <span *ngIf="person.cnp"> (CNP: {{ person.cnp }})</span>
                                                <br>
                                                <small>Relație: {{ person.relationship_type_name }}</small>
                                                <span *ngIf="person.relationship_specific_name"> | Grad rudenie: {{
                                                    person.relationship_specific_name
                                                    }}</span>
                                            </div>
                                            <button mat-icon-button color="warn" (click)="removeInvolvedPerson(i)"
                                                type="button">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <form [formGroup]="involvedPersonForm">
                                        <div class="row">
                                            <div class="col-md">
                                                <mat-form-field class="w-100" appearance="fill">
                                                    <mat-label>Nume complet</mat-label>
                                                    <input type="text" matInput formControlName="full_name" />
                                                    <mat-error
                                                        *ngIf="!involvedPersonForm.controls['full_name'].valid && involvedPersonForm.controls['full_name'].touched">
                                                        Nume complet este obligatoriu
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md">
                                                <mat-form-field class="w-100" appearance="fill">
                                                    <mat-label>CNP</mat-label>
                                                    <input type="text" matInput formControlName="cnp" />
                                                    <mat-error
                                                        *ngIf="involvedPersonForm.controls['cnp'].hasError('pattern') && involvedPersonForm.controls['cnp'].touched">
                                                        CNP nevalid (13 cifre)
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md">
                                                <!-- <mat-form-field class="w-100" appearance="fill">
                                                        <mat-label>Rol</mat-label>
                                                        <mat-select formControlName="id_relationship_type">
                                                            <mat-option value="">-- Alegeți --</mat-option>
                                                            <mat-option value="Copil">Copil</mat-option>
                                                            <mat-option value="Părinte">Părinte</mat-option>
                                                            <mat-option value="Tutore">Tutore</mat-option>
                                                            <mat-option value="Reprezentant legal">Reprezentant
                                                                legal</mat-option>
                                                            <mat-option value="Membru familie">Membru
                                                                familie</mat-option>
                                                            <mat-option value="altul">Altul</mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngIf="involvedPersonForm.controls['role'].hasError('required')">
                                                            Rol este obligatoriu
                                                        </mat-error>
                                                    </mat-form-field> -->
                                                <mat-form-field class="w-100" appearance="fill">
                                                    <mat-label>Relație</mat-label>
                                                    <mat-select formControlName="relationship_type_id"
                                                        (openedChange)="onRelatieTypeClosed()"
                                                        (selectionChange)="onRelatieTypeChange($event.value)">
                                                        <mat-form-field class="px-2 sticky-input">
                                                            <input matInput [formControl]="relatieTypeControl"
                                                                (keydown)="$event.stopPropagation()"
                                                                (click)="$event.stopPropagation()" />
                                                        </mat-form-field>
                                                        <mat-option *ngIf="filteredRelatieType.length === 0" disabled>
                                                            <span>Nu au fost găsite rezultate</span>
                                                        </mat-option>

                                                        <mat-option *ngFor="let item of filteredRelatieType"
                                                            [value]="item.id">
                                                            {{ item.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="!involvedPersonForm.controls['relationship_type_id'].valid && involvedPersonForm.controls['relationship_type_id'].touched">
                                                        Selectați o opțiune
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md">
                                                <!-- <mat-form-field class="w-100" appearance="fill">
                                                    <mat-label>Relație</mat-label>
                                                    <input type="text" matInput
                                                        formControlName="relationship_specific_id"
                                                        placeholder="ex: mamă, tată, frate, etc." />
                                                </mat-form-field> -->
                                                <mat-form-field class="w-100" appearance="fill">
                                                    <mat-label>Grad Rudenie</mat-label>
                                                    <mat-select formControlName="relationship_specific_id"
                                                        (openedChange)="onRelatieSpecificaClosed()"
                                                        (selectionChange)="onRelatieSpecificaChange($event.value)">
                                                        <mat-form-field class="px-2 sticky-input">
                                                            <input matInput [formControl]="relatieSpecificaControl"
                                                                (keydown)="$event.stopPropagation()"
                                                                (click)="$event.stopPropagation()" />
                                                        </mat-form-field>
                                                        <mat-option *ngIf="filteredRelatieSpecifica.length === 0"
                                                            disabled>
                                                            <span>Nu au fost găsite rezultate</span>
                                                        </mat-option>

                                                        <mat-option *ngFor="let item of filteredRelatieSpecifica"
                                                            [value]="item.id">
                                                            {{ item.name }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-md d-flex justify-content-end">
                                                <button class="btn btn-outline-primary btn-sm"
                                                    (click)="addInvolvedPerson()" type="button"
                                                    [disabled]="!involvedPersonForm.valid">
                                                    <i class="fa-solid fa-plus"></i>
                                                    Adaugă persoană
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </ng-container>
                            </form>

                            <form [formGroup]="filesForm">
                                <div class="solicitare-card__upload">
                                    <div class="solicitare-card__upload-header">
                                        <p class="upload-text">Fotografii/Documente</p>
                                        <button class="upload-btn" (click)="fileInputDocumentFiles.click()"
                                            type="button">
                                            <mat-icon class="upload-icon">cloud_upload</mat-icon> &nbsp;
                                            ÎNCARCĂ
                                        </button>
                                    </div>
                                    <div class="solicitare-card__upload-files" *ngIf="
                                        filesForm.value.files &&
                                        filesForm.value.files.length > 0 &&
                                        !uploading
                                    ">
                                        <div class="solicitare-card__upload-file" *ngFor="
                                            let uploadedFile of filesForm.value.files;
                                            let i = index
                                        ">
                                            <span class="solicitare-card__upload-file-name">
                                                {{
                                                uploadedFile.original_name.length > 30
                                                ? (uploadedFile.original_name | slice : 0 : 30) + ".."
                                                : uploadedFile.original_name
                                                }}
                                            </span>
                                            <div class="d-flex gap-4 align-items-center">
                                                <button class="solicitare-card__upload-file-view" type="button"
                                                    matTooltip="Vizualizează fișierul"
                                                    (click)="downloadTempFile(uploadedFile)">
                                                    <mat-icon class="btn-icon">visibility</mat-icon>
                                                    <span class="btn-text">Vizualizează</span>
                                                </button>
                                                <button class="solicitare-card__upload-file-delete" type="button"
                                                    matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                                                    <img class="btn-img" src="../../../assets/icons/delete.svg"
                                                        alt="" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                        *ngIf="uploading"></mat-spinner>

                                    <input type="file"
                                        accept=".png, .jpg, .jpeg, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ods, .odt"
                                        id="files_document" #fileInputDocumentFiles name="fileInputDocumentFiles"
                                        (change)="addFile($event)" multiple style="display: none" />
                                </div>
                            </form>

                            <h4 *ngIf="editData && uploadedFiles.length" class="my-2">Documente încărcate anterior </h4>
                            <div *ngIf="editData && uploadedFiles.length" class="d-flex flex-row flex-wrap gap-3">
                                <div *ngFor="let file of uploadedFiles; let i = index" class="position-relative">
                                    <button type="button" class="btn btn-outline-primary btn-sm"
                                        (click)="downloadFile(file.id)">
                                        <i class="fa-solid fa-download"></i>
                                        {{ file.original_name }}
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger p-1 small-absolute-btn d-flex"
                                        (click)="deleteFile(i)" title="Șterge">
                                        <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                                    </button>
                                </div>
                            </div>

                            <h4 *ngIf="editData && deletedFiles.length" class="my-2">Documente pregătite pentru ștergere
                            </h4>
                            <div *ngIf="editData && deletedFiles.length" class="d-flex flex-row flex-wrap gap-3">
                                <div *ngFor="let file of deletedFiles; let i = index" class="position-relative">
                                    <button type="button" class="btn btn-outline-primary btn-sm"
                                        (click)="downloadFile(file.id)">
                                        <i class="fa-solid fa-download"></i>
                                        {{ file.original_name }}
                                    </button>
                                    <button type="button" class="btn btn-sm btn-warning p-1 small-absolute-btn d-flex"
                                        (click)="restoreFile(i)" title="Anulează">
                                        <i class="fa-solid fa-times"></i>
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="filesForm.invalid && !uploadedFiles.length" class="mt-2">
                                <mat-error>
                                    Adăugați minim un document
                                </mat-error>
                            </div>

                            <mat-divider class="my-3"></mat-divider>

                            <!-- Submit -->
                            <div class="d-flex justify-content-end gap-2">
                                <button class="btn btn-secondary" type="button" (click)="toggleUploadPanel()">
                                    Anulează
                                </button>
                                <button class="btn btn-primary" type="button" (click)="submitUpload()" [disabled]="form.invalid || 
                                        !tagArr.length || 
                                        (!editData && filesForm.invalid) ||
                                        (editData && filesForm.invalid && !uploadedFiles.length)
                                    ">
                                    <i class="fa-solid fa-check"></i>
                                    {{ editData ? 'Editează Document' : 'Salvează Document' }}
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>